import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = [".open"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { slot: "footer" }
const _hoisted_6 = ["disabled"]

import { ref } from 'vue';
import { useStore } from 'vuex';
import Banner from '@components/Banner/Banner.vue';
import { ServiceInstance } from '../../models/service/ui-types';
import { useDeleteServiceInstance } from '../../queries/useServiceMutations';
import { useUnbindServiceInstance } from '../../queries/useServiceMutations';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceDeleteModal',
  setup(__props, { expose: __expose }) {

const showDeleteModal = ref<boolean>(false);
const serviceToDelete = ref<ServiceInstance | null>(null);

const store = useStore();
const t = store.getters['i18n/t'];

const {mutate: deleteServiceInstance, isPending: isDeletingServiceInstance, isError: deleteServiceInstanceError, error: deleteServiceInstanceErrorData} = useDeleteServiceInstance(store, handleSuccess);
const {mutateAsync: unbindService, isPending: isUnbindingService, isError: unbindServiceError, error: unbindServiceErrorData} = useUnbindServiceInstance(store);

function openDelete(row: ServiceInstance) {
  serviceToDelete.value = row;
  showDeleteModal.value = true;
}

function closeDelete() {
  showDeleteModal.value = false;
  serviceToDelete.value = null;
}

async function onSubmitDelete() {
    if (!serviceToDelete.value) {
        return;
    }
    if (serviceToDelete.value.boundApps?.length) {
        Promise.all([...serviceToDelete.value.boundApps.map(appName => unbindService({ namespace: serviceToDelete.value!.meta.namespace, serviceName: serviceToDelete.value!.meta.name, request: { appName } }))])
            .then(() => {
                deleteServiceInstance({ namespace: serviceToDelete.value!.meta.namespace, serviceName: serviceToDelete.value!.meta.name });
            })
            .catch((error) => {
                store.dispatch('growl/error', {
                    title: t('epinio.services.errors.unbind.error.title'),
                    message: error?.message || t('epinio.services.errors.unbind.error.message'),
                });
            });
    } else {
        deleteServiceInstance({ namespace: serviceToDelete.value.meta.namespace, serviceName: serviceToDelete.value.meta.name });
    }
}

function handleSuccess() {
  store.dispatch('growl/success', {
    title:   t('epinio.growl.serviceInstance.delete.success.title'),
    message: t('epinio.growl.serviceInstance.delete.success.message', { name: serviceToDelete.value?.meta.name }),
  });
  closeDelete();
}

__expose({
  openDelete
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    ".open": showDeleteModal.value,
    title: "Are you sure?",
    onModalClose: closeDelete
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode("You are attempting to delete the Instance ", -1)),
        _createElementVNode("strong", null, _toDisplayString(serviceToDelete.value?.meta.name), 1),
        _cache[1] || (_cache[1] = _createTextVNode(".", -1))
      ]),
      _cache[4] || (_cache[4] = _createTextVNode()),
      (serviceToDelete.value?.boundApps?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Caution: "),
              _createTextVNode("The following applications are bound to the Service Instance about to be deleted. Proceeding will unbind them prior to deletion.")
            ], -1)),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serviceToDelete.value?.boundApps || [], (app) => {
                return (_openBlock(), _createElementBlock("li", { key: app }, _toDisplayString(app), 1))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "No applications are bound to this Service Instance.")),
      _cache[5] || (_cache[5] = _createTextVNode()),
      (_unref(unbindServiceError))
        ? (_openBlock(), _createBlock(Banner, {
            key: 2,
            color: "error",
            label: _unref(unbindServiceErrorData)?.message || _unref(t)('epinio.services.errors.unbind')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _cache[6] || (_cache[6] = _createTextVNode()),
      (_unref(deleteServiceInstanceError))
        ? (_openBlock(), _createBlock(Banner, {
            key: 3,
            color: "error",
            label: _unref(deleteServiceInstanceErrorData)?.message || _unref(t)('epinio.services.errors.delete')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("trailhand-button", {
        variant: "secondary",
        class: "mr-10",
        onButtonClick: closeDelete
      }, "Cancel", 32),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _createElementVNode("trailhand-button", {
        disabled: _unref(isDeletingServiceInstance) || _unref(isUnbindingService),
        variant: "destructive",
        onButtonClick: onSubmitDelete
      }, _toDisplayString(_unref(isDeletingServiceInstance) || _unref(isUnbindingService) ? _unref(t)('generic.deleting') : _unref(t)('generic.delete')), 41, _hoisted_6)
    ])
  ], 40, _hoisted_1))
}
}

})